import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ApisDomains, type Configuration, type ServiceApiName } from '../utils/config/configuration.type';

export interface ConfigState {
  isProd: boolean;
  hasFrontMonitoring: boolean;
  hasMedallia: boolean;
  GTMTrackingID?: string;
  isFreeClosingAuthorized?: boolean;
  hideEventNotifications?: boolean;
  config: Configuration;
  hasLog: boolean;
}

const initialState: ConfigState = {
  isProd: true,
  hasFrontMonitoring: false,
  hasMedallia: false,
  GTMTrackingID: '',
  isFreeClosingAuthorized: false,
  hideEventNotifications: false,
  hasLog: true,
  config: {
    services: {
      ICARE_BACK: {
        url: '',
      },
      ONE_BOOKING_WIDGET: {
        url: '',
      },
    },
  },
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  extraReducers: builder => builder.addCase('resetStore', () => initialState),
  reducers: {
    setIsProd: (state, action: PayloadAction<boolean>) => {
      state.isProd = action.payload;
    },
    setHasFrontMonitoring: (state, action: PayloadAction<boolean>) => {
      state.hasFrontMonitoring = action.payload;
    },
    setHasMedallia: (state, action: PayloadAction<boolean>) => {
      state.hasMedallia = action.payload;
    },
    setGTMTrackingID: (state, action: PayloadAction<string>) => {
      state.GTMTrackingID = action.payload;
    },
    setIsFreeClosingAuthorized: (state, action: PayloadAction<boolean>) => {
      state.isFreeClosingAuthorized = action.payload;
    },
    setHideEventNotifications: (state, action: PayloadAction<boolean>) => {
      state.hideEventNotifications = action.payload;
    },
    setHasLog: (state, action: PayloadAction<boolean>) => {
      state.hasLog = action.payload;
    },
    updateDomains: (state, action: PayloadAction<ApisDomains>) => {
      const { urls } = action.payload;
      const { services } = state.config;
      Object.entries(urls).forEach(([key, value]) => {
        const typedKey = key as ServiceApiName;
        if (services[typedKey]) {
          services[typedKey].url = value;
        }
      });
    },
  },
});

export const {
  reducer: configReducer,
  actions: {
    setIsProd,
    setHasFrontMonitoring,
    setHasMedallia,
    updateDomains,
    setHasLog,
    setGTMTrackingID,
    setIsFreeClosingAuthorized,
    setHideEventNotifications,
  },
} = configSlice;
